export default __webpack_public_path__ + "static/media/work-3.572d9083.jpg";